var React = require('react');

function Banner (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"zap"},React.createElement("path",{"id":"Icon","d":"M13 2L3 14H12L11 22L21 10H12L13 2Z","stroke":"#473CFB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Banner.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Banner;

Banner.default = Banner;
